import React, { FC } from "react";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  MdaePopupFooterStartButtons,
} from "../../../../common_components/common_widgets/popup";
import MdaeButton from "../../../../common_components/common_widgets/button";
import "./index.scss";
import { useDispatch, useSelector } from "react-redux";
import { first, isEqual } from "lodash";
import "./index.scss";
import {
  caseDataValidationModes,
  defaultCaseDataWarningPopupData,
  TOGGLE_EA_CASE_DATA_WARNING_POPUP,
  UPDATE_ROUND_DATA,
} from "./reducers/case-data-reducer";
import MdaeDateBox from "../../../../common_components/common_widgets/date-box";
import { convertDateFormat } from "../../../../utils/dateUtils";
import { Validator } from "devextreme-react";
import { RequiredRule } from "devextreme-react/validator";
import {
  caseDataValidationGroup,
  toggleCaseDataValidationMode,
} from "./component";
import DateBox from "devextreme/ui/date_box";
import { validateAndSaveCaseData } from "../case-detail-common-functions";

export const EA_CASE_DATA_WARNING_POPUP_MODES = {
  CASE_STATUS_IS_REQUIRED: "CASE_STATUS_IS_REQUIRED",
  ADVANCE_TO_NEXT_ROUND: "ADVANCE_TO_NEXT_ROUND",
  ROUND_OUTCOME_IS_REQUIRED_WARNING: "ROUND_OUTCOME_IS_REQUIRED_WARNING",
  ROUND_OUTCOME_OF_TYPE_NOT_APPEAL_IS_SELECTED:
    "ROUND_OUTCOME_OF_TYPE_NOT_APPEAL_IS_SELECTED",
};
const warningsWithOnlyOKButton = [
  EA_CASE_DATA_WARNING_POPUP_MODES.ROUND_OUTCOME_IS_REQUIRED_WARNING,
  EA_CASE_DATA_WARNING_POPUP_MODES.ROUND_OUTCOME_OF_TYPE_NOT_APPEAL_IS_SELECTED,
  EA_CASE_DATA_WARNING_POPUP_MODES.CASE_STATUS_IS_REQUIRED,
];
interface IEACaseDataWarningPopup {
  caseRoundOutcomeSelectBoxInstance: any;
}

export const toggleEaCaseDataWarningPopupVisible = (
  dispatch,
  isVisible,
  popupMode?,
  caseDataWarningpopupData = { ...defaultCaseDataWarningPopupData }
) => {
  dispatch({
    type: TOGGLE_EA_CASE_DATA_WARNING_POPUP,
    data: {
      isEaCaseDataWarningPopupVisible: isVisible,
      eaCaseDataWarningPopupMode: popupMode,
      caseDataWarningpopupData,
    },
  });
};
const setValueOnDateBoxUIComponent = (id: string, value:string)  =>{
  const element = document.getElementById(id);
  if(element)
    DateBox.getInstance(element).option('value', value);
}

const EACaseDataWarningPopup: FC<IEACaseDataWarningPopup> = (props) => {
  const dispatch = useDispatch();

  const eaCaseDataWarningPopupMode: string = useSelector(
    (state) => state["caseDataReducer"].eaCaseDataWarningPopupMode,
    isEqual
  );

  const caseDataWarningpopupData = useSelector(
    (state) => state["caseDataReducer"].caseDataWarningpopupData,
    isEqual
  );
  const currentRoundCase = useSelector(
    (state) => first(state["caseDataReducer"].caseData.roundData),
    isEqual
  );
  const noAdditionalRound = useSelector(
    (state) =>
      state["externalAuditReducer"].processTemplateRoundList?.findIndex(
        (x) => x.sequenceNo === currentRoundCase?.sequenceNo + 1
      ) === -1,
    isEqual
  );
  const caseDataTabData = useSelector(
    (state) => state["caseDataReducer"].caseData,
    isEqual
  );
  const currentUser = useSelector(
    (state) => state["mdaeNavigationBarReducer"].currentUser,
    isEqual
  );
  const isCurrentRequesterReviewContractorValid = useSelector(
    (state) =>
      state["externalAuditReducer"].isCurrentRequesterReviewContractorValid,
    isEqual
  );
  const isCurrentContentTypeInvalidForReviewContractor = useSelector(
    (state) =>
      state["externalAuditReducer"]
        .isCurrentContentTypeInvalidForReviewContractor,
    isEqual
  );
  const focusToBrokenRule = (result, ruleName: string) => {
    result?.brokenRules
      .find((x) => x?.validator.option("name") === ruleName)
      ?.validator.focus();
  };
  const onEaCaseDataWarningPopupModePrimaryButtonClick = (
    submitButtonParams
  ) => {
    toggleCaseDataValidationMode(
      dispatch,
      caseDataValidationModes.ROUND_CASE_LEVEL
    );

    let result = null;
    let brokenRuleName = "";
    switch (eaCaseDataWarningPopupMode) {
      case EA_CASE_DATA_WARNING_POPUP_MODES.ADVANCE_TO_NEXT_ROUND:
        //first validate case data fields if
        if (submitButtonParams.validationGroup)
          result = submitButtonParams.validationGroup.validate();
        if (result && result.isValid) {
          toggleEaCaseDataWarningPopupVisible(dispatch, false);
          dispatch(validateAndSaveCaseData(
            submitButtonParams,
            isCurrentRequesterReviewContractorValid,
            isCurrentContentTypeInvalidForReviewContractor,
            null,
            false,
            false,
            caseDataValidationModes.ROUND_CASE_LEVEL,
            0,
            true
          ));
        }
        break;
      case EA_CASE_DATA_WARNING_POPUP_MODES.ROUND_OUTCOME_OF_TYPE_NOT_APPEAL_IS_SELECTED:
      case EA_CASE_DATA_WARNING_POPUP_MODES.ROUND_OUTCOME_IS_REQUIRED_WARNING:
        toggleEaCaseDataWarningPopupVisible(dispatch, false);
        props.caseRoundOutcomeSelectBoxInstance?.focus();
        break;
      case EA_CASE_DATA_WARNING_POPUP_MODES.CASE_STATUS_IS_REQUIRED:
        brokenRuleName = "caseStatusValidator";
        break;
    }

    if (brokenRuleName && submitButtonParams.validationGroup) {
      result = submitButtonParams.validationGroup.validate();
      toggleEaCaseDataWarningPopupVisible(dispatch, false);
      focusToBrokenRule(result, brokenRuleName);
    }
  };

  const getPopupTitle = () => {
    return (
      <MdaePopupTitle
        isSmallPopup
        closePopupHandler={() => {
          toggleEaCaseDataWarningPopupVisible(dispatch, false);
        }}
      >
        Warning
      </MdaePopupTitle>
    );
  };

  return (
    <MdaePopup
      autoHeight
      deferRendering={false}
      width={500}
      height={"auto"}
      className="ea-case-data-warning-popup"
      onInitialized={(e) => {
        (window as any).caseDataWarningPopup = e.component;
      }}
      mdaeTitleRender={getPopupTitle}
      onHiding={() =>{
        toggleCaseDataValidationMode(
          dispatch,
          caseDataValidationModes.CASE_LEVEL
        );
      }}
      mdaeDataUpdaterConfig={[
        {
          actionType: TOGGLE_EA_CASE_DATA_WARNING_POPUP,
          reducerName: "caseDataReducer",
          widgetOptionBindings: {
            visible: "isEaCaseDataWarningPopupVisible",
          },
        },
      ]}
      mdaeContentRender={() => {
        return (
          <div>
            <MdaePopupContent>
              {/* conditional rendering based on warning popup mode */}
              {eaCaseDataWarningPopupMode ===
                EA_CASE_DATA_WARNING_POPUP_MODES.ADVANCE_TO_NEXT_ROUND && (
                <>
                  {!caseDataWarningpopupData.hasStartDate && (
                    <div className="top-margin">
                      The current round start date must be populated before the
                      next round is created. Please enter a start date here:
                      <div className="top-margin">
                        <MdaeDateBox
                          id="dtStartDateFromWarning"
                          mdaeDateBoxTitle=""
                          onValueChanged={(e) => {
                            if (e.event)
                              dispatch({
                                type: UPDATE_ROUND_DATA,
                                data: {
                                  roundId: currentRoundCase.eaRoundId,
                                  value: convertDateFormat(e.value),
                                  propName: "roundStartDate",
                                },
                              });
                              setValueOnDateBoxUIComponent(
                                "dtCaseLevelRoundStartDate" +
                                  currentRoundCase.eaRoundId,
                                convertDateFormat(e.value)
                              );
                          }}
                        >
                          <Validator validationGroup={caseDataValidationGroup}>
                            <RequiredRule message="Start Date is required" />
                          </Validator>
                        </MdaeDateBox>
                      </div>
                    </div>
                  )}
                  {!caseDataWarningpopupData.hasActualSubmissionDate && (
                    <>
                      <div className="top-margin">
                        The current round actual submission date must be
                        populated before the next round is created. Please enter
                        a submission date here:
                      </div>
                      <div className="top-margin">
                        <MdaeDateBox
                          id="dtSubmissionDateFromWarning"
                          mdaeDateBoxTitle=""
                          onValueChanged={(e) => {
                            if (e.event)
                              dispatch({
                                type: UPDATE_ROUND_DATA,
                                data: {
                                  roundId: currentRoundCase.eaRoundId,
                                  value: convertDateFormat(e.value),
                                  propName: "actualSubmissionDate",
                                },
                              });
                              setValueOnDateBoxUIComponent(
                                "dtActualSubmissionDate" +
                                  currentRoundCase.eaRoundId,
                                convertDateFormat(e.value)
                              );
                          }}
                        >
                          <Validator validationGroup={caseDataValidationGroup}>
                            <RequiredRule message="Submission Date is required" />
                          </Validator>
                        </MdaeDateBox>
                      </div>
                    </>
                  )}
                  {!caseDataWarningpopupData.hasRoundDeterminationDate && (
                    <>
                      <div className="top-margin">
                        The current round determination date must be populated
                        before the next round is created. Please enter a
                        determination date here:
                      </div>
                      <div className="top-margin">
                        <MdaeDateBox
                          id="dtDeterminationDateFromWarning"
                          mdaeDateBoxTitle=""
                          onValueChanged={(e) => {
                            if (e.event)
                              dispatch({
                                type: UPDATE_ROUND_DATA,
                                data: {
                                  roundId: currentRoundCase.eaRoundId,
                                  value: convertDateFormat(e.value),
                                  propName: "roundDeterminationDate",
                                },
                              });
                              setValueOnDateBoxUIComponent(
                                "dtRoundDeterminationDate" +
                                  currentRoundCase.eaRoundId,
                                convertDateFormat(e.value)
                              );
                          }}
                        >
                          <Validator validationGroup={caseDataValidationGroup}>
                            <RequiredRule message="Determination Date is required" />
                          </Validator>
                        </MdaeDateBox>
                      </div>
                    </>
                  )}

                  {noAdditionalRound && (
                    <div className="top-margin">
                      No additional rounds are associated with the current
                      process. Do you want to manually create a new round?
                    </div>
                  )}
                  {caseDataWarningpopupData.hasActualSubmissionDate &&
                    caseDataWarningpopupData.hasRoundDeterminationDate &&
                    caseDataWarningpopupData.hasStartDate && (
                      <div className="top-margin">
                        Do you want to advance to the next round? This action
                        cannot be undone.
                      </div>
                    )}
                </>
              )}

              {eaCaseDataWarningPopupMode ===
                EA_CASE_DATA_WARNING_POPUP_MODES.ROUND_OUTCOME_IS_REQUIRED_WARNING && (
                <div>
                  Cases must have a round outcome to advance to the next round.
                  Please add a round outcome to the case.
                </div>
              )}

              {eaCaseDataWarningPopupMode ===
                EA_CASE_DATA_WARNING_POPUP_MODES.ROUND_OUTCOME_OF_TYPE_NOT_APPEAL_IS_SELECTED && (
                <div>
                  Cases without a round outcome type of Appeal cannot be moved
                  to the next round. Update the last round outcome to an appeal
                  type to advance to the next round.
                </div>
              )}

              {eaCaseDataWarningPopupMode ===
                EA_CASE_DATA_WARNING_POPUP_MODES.CASE_STATUS_IS_REQUIRED && (
                <div>
                  Cases without a case status cannot be moved to the next round.
                  Update the case status to advance to the next round.
                </div>
              )}
            </MdaePopupContent>
          </div>
        );
      }}
      mdaeFooterRender={() => {
        return (
          <MdaePopupFooter>
            {/* {warningsWithOnlyOKButton.includes(eaCaseDataWarningPopupMode) ||  */}
            {
              <MdaePopupFooterStartButtons>
                <MdaeButton
                  id={"pnlEaCaseDataWarningPopupSecondaryButton"}
                  role={"secondary"}
                  onClick={() => {
                    toggleEaCaseDataWarningPopupVisible(dispatch, false);
                  }}
                >
                  Cancel
                </MdaeButton>
              </MdaePopupFooterStartButtons>
            }

            <MdaePopupFooterEndButtons>
              <MdaeButton
                id={"pnlEaCaseDataWarningPopupPrimaryButton"}
                role={"primary"}
                validationGroup={caseDataValidationGroup}
                onClick={(submitButtonParams) => {
                  onEaCaseDataWarningPopupModePrimaryButtonClick(
                    submitButtonParams
                  );
                }}
              >
                OK
              </MdaeButton>
            </MdaePopupFooterEndButtons>
          </MdaePopupFooter>
        );
      }}
    ></MdaePopup>
  );
};

export default EACaseDataWarningPopup;
